
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's182ab2d6c997515f': `Додайте на Домашній екран для зручного доступу та ширших можливостей.`,
's224cbcec014ef6b5': `Натиснути «Поділитися»`,
's37a9e8aec5713460': `Детальніше`,
's386eca8362ff6155': `Натисніть «Більше», якщо немає значка «Поділитися»`,
's4e1e10a6ca408245': `Натиснути «На Початковий экран»`,
's6196153c4b0c1ea0': `Встановити`,
's633502f7cff4f847': `Відкрити меню браузера`,
's681e399d63311fba': `Показати галерею`,
's7f0591f08e318eda': `Натисніть «Більше» в меню «Поділитися»`,
's8114bd55cae5a22b': `Натиснути «Додати на Dock»`,
's922329d6f6213590': `Додати на Dock`,
's9af56bf005b49c74': `Прокрутіть вниз до «На Початковий экран»`,
'sa5ef80b4bb9b39f8': `Згорнути`,
'sba52286c21552a4e': `Встановіть на ваш пристрій для зручного доступу та ширших можливостей.`,
'sc16e00a7a8b2fde2': `Назад`,
'scdaf4bbff76674c8': `На Початковий экран`,
'se0e473adfda8066c': `Відкрити у вашому основному браузері`,
'se740f75b95a51807': `Додайте на панель Dock для зручного доступу та ширших можливостей.`,
'sfea652f6580ff086': `Цей сайт має функції додатку.`,
    };
  